var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "mer",
    cx: "35%",
    cy: "30%",
    r: "85%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d7dee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#9aa5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4d5660"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "url(#mer)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d454e",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 62,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 88,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 134,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 104,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 116,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 56,
    r: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercury);
export default __webpack_public_path__ + "static/media/mercury.a4a3a236da37908b43197f64fb7ec5e4.svg";
export { ForwardRef as ReactComponent };